import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from 'utils/is-mobile';
import { NewCasinoCategory } from 'interfaces/new-casino';
import {
  getCasinoCustomCategories,
  getCasinoOriginalCategories,
  getCasinoOriginalCategoriesSet,
  getCasinoOriginalCategoriesSetLeftSideBar
} from 'store/selectors/new-casino';

export const useCategories = (
  leftSidebar = false
): NewCasinoCategory[] | null => {
  const originalCategories = useSelector(getCasinoOriginalCategories);
  const customCategories = useSelector(getCasinoCustomCategories);
  const originalCategoriesSet = useSelector(getCasinoOriginalCategoriesSet);
  const originalCategoriesSetLeftSideBar = useSelector(
    getCasinoOriginalCategoriesSetLeftSideBar
  );

  return useMemo(() => {
    if (originalCategories === null) {
      return null;
    } else {
      const allCategories = [...customCategories, ...originalCategories];

      const categoriesSet =
        leftSidebar && !isMobile()
          ? originalCategoriesSetLeftSideBar
          : originalCategoriesSet;

      if (categoriesSet?.length) {
        return allCategories.filter(cat => categoriesSet.includes(cat.id));
      } else {
        return allCategories;
      }
    }
  }, [
    originalCategories,
    customCategories,
    originalCategoriesSet,
    originalCategoriesSetLeftSideBar
  ]);
};
